module.exports = __webpack_public_path__ + "static/media/index_03.bcd812e9.png";